module.exports = __webpack_public_path__ + "img/character-typing-cat.5ed8cb25.png";